import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';

import { billPresentmentActions } from 'app-components/flux/bill-presentment';
import { rootUiActions } from 'app-components/flux/root-ui';
import { scheduledTransactionsActions } from 'app-components/flux/scheduled-transactions';

import StdDialogTitle from 'components/Dialogs/StdDialogTitle';
import { useAppDispatch } from 'hooks/redux';

import { DETAILS_DIALOG_TYPE, type BillPresentmentDetailsProps } from './actions';
import { PendingView } from './HoldingScreen';
import LoginView from './LoginView';
import { StepEnum } from './types';

type Props = BillPresentmentDetailsProps & {
  dialogId?: string;
};

export default function BillPresentmentDetailsDialog({
  biller,
  dialogId,
  enrollment,
  guid,
  series,
}: Props): React.JSX.Element {
  const dispatch = useAppDispatch();
  const [step, setStep] = useState(StepEnum.LOGIN);
  const resolvedDialogId = dialogId ?? `${DETAILS_DIALOG_TYPE}-${series.id}`;

  const close = (): void => {
    dispatch(rootUiActions.removeDialog(resolvedDialogId, { animate: true }));
  };

  const finish = (): void => {
    window.setTimeout(() => {
      dispatch(billPresentmentActions.fetch());
      dispatch(scheduledTransactionsActions.getScheduledTransactions());
    }, 500);
    close();
    dispatch(rootUiActions.removeDialog(`BPS-${series.id}`, { animate: true }));
  };

  return (
    <Box
      aria-label='Connect biller details'
      role='dialog'
      sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }}
    >
      <StdDialogTitle
        variant='drawer'
        id='bill-presentment-details-title'
        onBack={step === StepEnum.LOGIN ? close : undefined}
        onClose={close}
        showBackButton={step === StepEnum.LOGIN}
        showCloseButton
      >
        Connect biller
      </StdDialogTitle>
      <Box
        sx={{
          flex: '1 1 auto',
          minHeight: 0,
          overflow: step === StepEnum.LOGIN ? 'hidden' : 'auto',
        }}
      >
        {step === StepEnum.LOGIN ? (
          <LoginView GUID={guid} biller={biller} enrollment={enrollment} isDrawer series={series} setSteps={setStep} />
        ) : (
          <PendingView />
        )}
      </Box>
      {step === StepEnum.PENDING ? (
        <DialogActions>
          <Button id='bill-connect-finish' variant='outlined' onClick={finish}>
            Close
          </Button>
        </DialogActions>
      ) : null}
    </Box>
  );
}
